import { useRouterHistory } from 'react-router';
import { createHistory } from 'history';
import { syncHistoryWithStore } from 'react-router-redux';
import store from './store';

const baseHistory = useRouterHistory(createHistory)({
  basename: BASE_PATH,
});

const history = syncHistoryWithStore(baseHistory, store);

export default history;
